import {initializeApp} from "firebase/app";
import {getFirestore} from 'firebase/firestore';
import {getDatabase, ref, onValue, update, onChildChanged} from 'firebase/database';
import {
    getAuth,
    signInWithPhoneNumber,
    signInWithCustomToken,
    signInWithEmailAndPassword,
    RecaptchaVerifier
} from 'firebase/auth';
import {collection, getDocs, query, orderBy, where, onSnapshot, setDoc, updateDoc, doc} from "firebase/firestore";
import {deepCopy, isObjectEmpty} from "./utils/utils";
import {logEvent, getAnalytics} from 'firebase/analytics';

// https://firebase.google.com/docs/web/setup#available-libraries
const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket:process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const firestoreDB = getFirestore(app);
const realTimeDB = getDatabase(app);
const auth = getAuth(app);
const analytics = getAnalytics();

const logEventTest = () => {
    try {
        logEvent(
            analytics,
            'app-download', {
                location: 'Test',
            });
    } catch (error) {
        console.log('error', error)
    }
}

const logout = async () => {
    await auth.signOut();
}

const logInWithToken = async () => {
    try {
        let result = await signInWithCustomToken(
            auth,
            'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdWQiOiJodHRwczovL2lkZW50aXR5dG9vbGtpdC5nb29nbGVhcGlzLmNvbS9nb29nbGUuaWRlbnRpdHkuaWRlbnRpdHl0b29sa2l0LnYxLklkZW50aXR5VG9vbGtpdCIsImlhdCI6MTY3MDkzOTQ5MiwiZXhwIjoxNjcwOTQzMDkyLCJpc3MiOiJmaXJlYmFzZS1hZG1pbnNkay1jaHRnbkBsb3ZldGVubmlzLTY4MDA2LmlhbS5nc2VydmljZWFjY291bnQuY29tIiwic3ViIjoiZmlyZWJhc2UtYWRtaW5zZGstY2h0Z25AbG92ZXRlbm5pcy02ODAwNi5pYW0uZ3NlcnZpY2VhY2NvdW50LmNvbSIsInVpZCI6IldPV1l0UmpQOEtNbnQ4cHF5V2FIM2pZUDFqaDIifQ.SREaqNnre9Qen5dwPh0PM4GDTtmPJ45_3cJgsbHw2zl50N94lE94x1HAiqMt0NZrj4tXczeYFL_bJ1I4Cf8-Q5brvm3EpX1fN5tqW0ZlIkwizu7s-38RRplxgiI6slo_LgkijyAv4lHdbX2fkuBzHRnuH-8pPnaA4f0soiR_Mf5bopFJY9yOQYpkPgqpYacr2cO37LK8gXEhTABfInJqwZptDBy7sfcCibLbR1e0wCeg4ReGpSA7pWYhGQER0GDbaXsL8fYV6tFZJ6kh6pw3Dq39fh4s2AMN1UpqBQIlMUv9J_1iNAy_uo7FMmlP9y5MSERAWIwES6J9BEH1lppDlQ'
        );

        console.log('token result', result)
    } catch (error) {
        console.log('error', error)
    }
};

const logInWithEmailPassword = async (email, password, successHandler, failureHandler) => {
    try {
        let result = await signInWithEmailAndPassword(
            auth,
            email,
            password
        );

        console.log('emailPassword result', result)

        if (successHandler) {
            successHandler();
        }

    } catch (error) {
        console.log('error', error)

        if (failureHandler) {
            failureHandler()
        }
    }
};

const logInWithPhone = async (phoneNumber, confirmCode, completionHandler) => {
    console.log('logInWithPhone')

    try {
        // TODO: need to slap this onto a div element
        let verify = new RecaptchaVerifier('recaptcha-container', {}, auth);
        // console.log('verify', verify)
        let confirmationResult = await signInWithPhoneNumber(auth, '+15555555555', verify);
        console.log('confirmationResult', confirmationResult)

        let result = await confirmationResult.confirm('555555');
        console.log('result', result)
        completionHandler(result);
    } catch (err) {
        console.error(err);
        alert(err.message);
    }
};

// const onListenToCourtSubmissions = (callback) => {
//     let query = ref(realTimeDB, 'courtSubmissions');
//     let unsubscribe = onChildChanged(query, (snapshot) => {
//         const data = snapshot.val();
//         console.log('onlistenToCourtSubmissions', data)
//         console.log('Object.values(data)', Object.values(data)[0])
//
//         callback(Object.values(data)[0]);
//     });
//
//     return unsubscribe;
// }

const onListenToCourtSubmissions = (callback) => {
    let query = ref(realTimeDB, 'courtSubmissions');
    let unsubscribe = onValue(query, (snapshot) => {
        const data = snapshot.val();

        callback(data);
    });

    return unsubscribe;
}

const getCourtSubmissions = async () => {
    return await new Promise(async resolve => {

        let query = ref(realTimeDB, 'courtSubmissions');

        onValue(query, (snapshot) => {
            const data = snapshot.val();
            // console.log('data', data)
            if (snapshot.exists()) {
                resolve(data);
            } else {
                resolve(null);
            }
        }, (error) => {
            console.log('error', error)
            resolve(null);
        });
    });
};

const getCourtCorrections = async () => {
    return await new Promise(async resolve => {

        let query = ref(realTimeDB, 'courtReportIssues');

        onValue(query, (snapshot) => {
            const data = snapshot.val();
            if (snapshot.exists()) {
                resolve(data);
            } else {
                resolve(null);
            }
        }, (error) => {
            console.log('error', error)
            resolve(null);
        });
    });
};

const archiveCourtSubmission = async (userId, courtId, isVerified = true) => {
    return await new Promise(async resolve => {

        let updateRef = ref(realTimeDB, `courtSubmissions/${userId}/${courtId}`);
        await update(updateRef, {isVerified: isVerified, hasBeenProcessed: true, processDate: new Date()});

        resolve();
    });
}

const addCourtToTennisCourts = async (court) => {
    return await new Promise(async resolve => {
        const courtRef = doc(firestoreDB, 'tennisCourts', court.id);
        await setDoc(courtRef, court);
        resolve();
    });
};

const updateCourtsForUser = async (user, clubCourts) => {
    return await new Promise(async resolve => {
        const userRef = doc(firestoreDB, 'users', user.id);
        await updateDoc(userRef, {clubCourts: clubCourts});
        resolve();
    });
};

const getLastOnline = async () => {
    return await new Promise(async resolve => {
        const query = ref(realTimeDB, 'onlineLast');

        onValue(query, (snapshot) => {
            const data = snapshot.val();
            resolve(data);
        });
    });
}

const getUsers = async (usersFilter) => {
    return await new Promise(async resolve => {

        let userQuery;
        if (usersFilter) {
            userQuery = query(
                collection(firestoreDB, 'users'),
                where('id', 'in', usersFilter),
            );
        } else {
            userQuery = query(
                collection(firestoreDB, 'users'),
                where('hasCompletedOnboarding', '==', true),
            );
        }

        let result = await getDocs(userQuery);
        let users = [];
        for (let i in result.docs) {
            const doc = result.docs[i];
            let user = doc.data();

            users.push(user);
        }

        resolve(users);
    });
}

const rejectCourt = async (courtData) => {
    let courtDataCopy = deepCopy(courtData);
    let user = deepCopy(courtDataCopy.submittedByUser);
    await archiveCourtSubmission(user.id, courtDataCopy.id, false);
}

const approveUpdateCourtInfo = async (courtData) => {
    if (isObjectEmpty(courtData)) {
        return;
    }


};

const rejectUpdateCourtInfo = async (courtData) => {
    if (isObjectEmpty(courtData)) {
        return;
    }


};

const approveCourt = async (courtData) => {
    if (isObjectEmpty(courtData)) {
        return;
    }

    let courtDataCopy = deepCopy(courtData);
    let user = deepCopy(courtDataCopy.submittedByUser);
    let userCourt = user?.clubCourts.find(court => court.id == courtDataCopy.id);

    delete courtDataCopy['submittedByUser'];

    // console.log('userCourt found?', userCourt)
    // console.log('courtDataCopy', courtDataCopy)
    // console.log('user', user)

    // validate courtDataCopy fields?

    // add to tennisCourts
    courtDataCopy.isVerified = true;

    await addCourtToTennisCourts(courtDataCopy);

    if (user && userCourt) {
        let userCourtIds = user.clubCourts.map(court => court.id)
        let foundIndex = userCourtIds.indexOf(courtDataCopy.id);
        let updateCourt = user.clubCourts[foundIndex];

        if (updateCourt) {
            user.clubCourts[foundIndex] = courtDataCopy;
        }

        // find current user and update their court
        await updateCourtsForUser(user, user.clubCourts);
    }

    // archive court so it does not display
    await archiveCourtSubmission(user.id, courtDataCopy.id);
};

export {
    auth,
    firestoreDB,
    realTimeDB,
    logInWithPhone,
    logout,
    logInWithToken,
    logInWithEmailPassword,
    getCourtSubmissions,
    getCourtCorrections,
    getUsers,
    approveCourt,
    approveUpdateCourtInfo,
    rejectUpdateCourtInfo,
    onListenToCourtSubmissions,
    rejectCourt,
    getLastOnline,
    logEventTest,
};
